var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"partners-section"},[_c('h2',{staticClass:"partners-section__title"},[_vm._v("Тарифы")]),_c('PartnersTabs',{on:{"input":_vm.setActiveCat}}),_c('PartnersTariff',{attrs:{"tariffs":_vm.activeTariffs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }